// src/admin/components/dashboard/BusinessGrowthByCountry.tsx
import React from 'react';

interface CountryGrowth {
  country: string;
  flag: string; // Emoji or image URL
  revenue: number; // Changed to number
  growthPercentage: number; // Changed to number
}

interface BusinessGrowthByCountryProps {
  data: CountryGrowth[];
}

const BusinessGrowthByCountry: React.FC<BusinessGrowthByCountryProps> = ({ data }) => {
  // Helper to format numbers to M/K
  const formatCurrencyGrowth = (value: number) => {
    if (value >= 1000000) {
      return `${(value / 1000000).toFixed(2)} M`;
    } else if (value >= 1000) {
      return `${(value / 1000).toFixed(0)} K`;
    }
    return `${value}`;
  };

  return (
    <div className="space-y-4">
      {data.map((item, index) => (
        <div key={index} className="flex items-center justify-between">
          <div className="flex items-center w-1/3">
            <span className="text-2xl mr-2">{item.flag}</span>
            <span className="font-medium text-gray-800">{item.country}</span>
          </div>
          <div className="w-1/3 text-right">
            <span className="text-gray-700">Revenue: </span>
            <span className="font-semibold text-gray-900">{formatCurrencyGrowth(item.revenue)}</span>
          </div>
          <div className="w-1/6 text-right">
            <span className="text-green-600 font-semibold">{item.growthPercentage}%</span>
          </div>
          <div className="w-1/6 ml-4">
            <div className="w-full bg-gray-200 rounded-full h-2.5">
              <div
                className="bg-green-500 h-2.5 rounded-full"
                style={{ width: `${item.growthPercentage}%` }}
              ></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BusinessGrowthByCountry;